export default __webpack_public_path__ + "static/media/Truck gif.740f3107.gif";